import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';
import { CurvedBoxComponent } from 'curved-box';
import { LinkComponent } from 'link';
import { BenefitsListSlice } from './benefits-list.slice';

@Component({
  selector: 'app-benefits-list',
  templateUrl: './benefits-list.component.html',
  standalone: true,
  imports: [DynamicHooksComponent, LinkComponent, CurvedBoxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BenefitsListComponent {
  @Input() slice: BenefitsListSlice;
}
